module.exports = __webpack_public_path__ + "img/UntenImSchachtFuesseUntenTransp.7492b7ad.png";